import { Config } from '@catalogo/core-configuration';
import { getEventLabel, getFreightInfo, getErrorMessage } from './helpers';
import { PageLoadEvent, FreightEvent } from '../../../types/events';
import { FreightDatalayer } from '../../../types/datalayer/freight-calculate';
import { PAGETYPES, eventData } from '../../../types/datalayer/datalayer';
import getDefaultEventPayload from '../default-event';

export default (events: eventData, eventType: string, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const freightEvent = events[eventType][0] as FreightEvent;
  const defaultEventPayload = getDefaultEventPayload(pageload, config);

  const action: Record<string, string> = { 'freight:error': 'error', 'freight:calculate': 'sucesso' };

  const freight = freightEvent.detail?.freight || {};
  const { freightId, cep, errorCode } = freight;
  const options = freight.options || [];
  const pagetype = PAGETYPES[pageload.detail?.page.type];

  const event: FreightDatalayer = {
    ...defaultEventPayload,
    event: 'freight_calculate',
    eventCategory: 'frete',
    eventAction: action[eventType],
    eventLabel: getEventLabel(options),
    eventValue: undefined,
    freightError: getErrorMessage(errorCode),
    freightCEP: cep,
    freightID: freightId,
    freightInfo: getFreightInfo(pagetype, options),
  };

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};
